var _title, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "circle-add")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,38.4A18.4,18.4,0,1,1,38.4,20,18.42,18.42,0,0,1,20,38.4Zm0-34A15.65,15.65,0,1,0,35.65,20,15.67,15.67,0,0,0,20,4.35Z",
    fill: "#231f20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.93,30.64a1.37,1.37,0,0,1-1.37-1.37V11.09a1.38,1.38,0,1,1,2.75,0V29.27A1.37,1.37,0,0,1,19.93,30.64Z",
    fill: "#231f20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27,21.31H11.09a1.38,1.38,0,1,1,0-2.75H29.27a1.38,1.38,0,0,1,0,2.75Z",
    fill: "#231f20"
  })));
}

export default SvgCircleAdd;